import request from '@/util/request'
import store from '../store/store'

// 查询设备流量卡信息（可强制刷新）
export function queryDeviceSimCard (data) {
  let token = store.getters.get_token
  return request({
    url: '/device/simcard',
    method: 'post',
    params: { token: token },
    data
  })
}

// 查询当前用户所有名下设备的流量卡汇总列表 (支持传入 { refresh: 1 } 实时向运营商刷新)
export function queryUserSimCards (params = {}) {
  let token = store.getters.get_token
  return request({
    url: '/user/simcards',
    method: 'get',
    params: { token: token, ...params }
  })
}



// WEBPACK FOOTER //
// ./src/api/simcard.js